import { http } from "@/http/axios.js";

export const MENU_TYPE = [
  { name: "目录", value: 1 },
  { name: "菜单", value: 2 },
  { name: "按钮", value: 3 },
];

export function getDictEnumListAPI(dictCode) {
  return http({
    url: "/adminapi/sys/dictEnum/list",
    method: "get",
    params: { dictCode },
  }).then((res) => {
    return res.map((item) => {
      return {
        name: item.enumText,
        value: item.enumCode,
      };
    });
  });
}

export const PRODUCT_CLIENT_DICT = [
  { label: "H5", value: 1 },
  { label: "APP", value: 2 },
];

export const COOPERATION_METHOD_DICT = [
  { label: "H5", value: 1 },
  { label: "联登", value: 2 },
  { label: "API", value: 3 },
];

export const PRODUCT_PUSH_DICT = [
  { label: "主动点击", value: 1 },
  { label: "自动推送", value: 2 },
];

export const OPERATOR_DICT = [
  { name: "大于等于", value: "ge" },
  { name: "大于", value: "gt" },
  { name: "等于", value: "eq" },
  { name: "小于", value: "lt" },
  { name: "小于等于", value: "le" },
  { name: "介于", value: "between" },
];
